export const warningCircled =
  'M214 55A111.7 111.7 0 0 0 55.8 41.5a114.3 114.3 0 0 0-13.6 159.8A111.2 111.2 0 0 0 200.1 215 114 114 0 0 0 214 55zm-86 158.3c-46.7 0-84.2-38.3-84.2-85.3S81.3 42.7 128 42.7 212.4 81 212.4 128s-37.8 85.3-84.5 85.3zM114.3 62.6h27.5v88.9h-27.5zm0 103.2h27.5v27.5h-27.5z'
